const CARD_SLIDER_CONF = {
  dots: false,
  enabled: true,
  autoplay: false,
  infinite: false,
  draggable: true,
  centerMode: false,
  speed: 300,
  slide: 'div',
  touchMove: true,
  touchThreshold: 5,
  respondTo: 'slider',
  variableWidth: true,
  slidesToScroll: 4,
  responsive: [ {
    breakpoint: 768,
    settings: {
      arrows: false,
      slidesToScroll: 2
    }
  },
  {
    breakpoint: 576,
    settings: {
      arrows: false,
      slidesToScroll: 1
    }
  }
  ]
},
  bigSliderCommons = {
    autoplay: true,
    infinite: true,
    speed: 300,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1
  },
  GALLERY_FULL_SCREEN_SLIDER_CONF = {
    dots: false,
    enabled: true,
    autoplay: false,
    infinite: false,
    draggable: true,
    centerMode: false,
    speed: 300,
    slide: 'div',
    touchMove: true,
    touchThreshold: 5,
    respondTo: 'slider',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [ {
      breakpoint: 768,
      settings: {
        arrows: false
      }
    } ]
  },
  PRINCIPAL_SLIDER_CONF = Object.assign({}, bigSliderCommons, {
    dots: true,
    pauseOnHover: false,
    pauseOnDotsHover: true,
    responsive: [ {
      breakpoint: 568,
      settings: {
        arrows: false
      }
    } ]
  }),
  FLIPSTER_SLIDER_CONF = Object.assign({}, bigSliderCommons, {
    centerMode: true,
    centerPadding: '30%',
    responsive: [ {
      breakpoint: 1920,
      settings: {
        centerMode: true,
        centerPadding: '30%',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 1300,
      settings: {
        centerMode: true,
        centerPadding: '25%',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 1100,
      settings: {
        centerMode: true,
        centerPadding: '22%',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 1000,
      settings: {
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 900,
      settings: {
        centerMode: true,
        centerPadding: '15%',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '5%',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 420,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '0%',
        slidesToShow: 1
      }
    }
    ]
  })
export const SliderConfs = {
  CARD_SLIDER_CONF,
  PRINCIPAL_SLIDER_CONF,
  GALLERY_FULL_SCREEN_SLIDER_CONF,
  FLIPSTER_SLIDER_CONF
}
